import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../base.component';
import { SharedService } from '../shared.service';
import { TechnicianService } from 'app/layout/admin/technician/technician.service';
import { GeoFencingMap, GeoFencingMapOption } from 'app/layout/admin/technician/technician.models';
import { LoaderService } from '../loader.service';
import { Severities } from '../shared.model';
import { CapitalizeFirstPipe } from '../pipes/custom-pipes.pipe';

declare var Microsoft: any;
declare var google: any;
@Component({
    // moduleId: module.id,
    selector: 'gps-location-popup',
    templateUrl: 'gps-location-popup.component.html',
    styles: [`
    .LatLon{
        background: #d1e1fb;       
        width: 100%;
        padding: 5px 10px;
        margin-bottom: 5px;
        font-size: 13px;
        color: #032b2b;
        border-radius: 4px;
    }
    .LatLon img{
        width: 20px;
    }
    .blder{
        font-weight: bolder;
        margin-bottom: 4px;
        display: block;
    }
    .LatLon .reasontxt{
        font-size: 12px;
        color: #0c4a39;
    }
    .LatLon .reasontxt i{
        font-size: 14px;
        color: #404040;
        width: 23px;
        display: inline-block;
    }
    .LatLon .display-inline
    {
        display:inline-block;
    }
    .LatLon .separater{
        display: inline-block;
        width: 15px;
        text-align: center;
        color: #f55;
    }
    `],
    providers: [DatePipe, TechnicianService]
})

export class GpsLocationPopupComponent extends BaseComponent implements OnInit {
    @Output() done = new EventEmitter();
    @Input() LatLon: string;
    @Input() Type: number = 1;//Type = '1' Means GeoTagging , '2' Means GeoFencing
    mapId: string;
    completed: string;
    onsite: string;
    Lat: string;
    Lon: string;
    GeoFencingMap: GeoFencingMap[] = [];
    MapOption: GeoFencingMapOption[] = [];

    constructor(public sharedService: SharedService, public translate: TranslateService, private technicianService: TechnicianService,
        private loaderService: LoaderService) {
        super(sharedService, translate);
    }

    ngOnInit(): void {
        let gi = super.globalInfo();
        this.mapId = gi.MapId;
        this.onsite = '../../../../../../assets/img/live-map/onsite.png';
        this.completed = '../../../../../../assets/img/live-map/completed.png';
        let ll = this.LatLon.split(',');
        this.Lat = ll[0];
        this.Lon = ll[1];
        if (this.Type == 2) {
            this.loaderService.show();
            this.technicianService.getGeoFencingDetails(gi.CompanyId, gi.LoginId, +this.LatLon).subscribe(
                s => {
                    this.GeoFencingMap = s;
                    if (s.filter(f => f.Moblat == null).length == 2)
                        this.MapOption = [];
                    else
                        this.LiveMap(this.LatLon, 2, s);
                    this.loaderService.hide();
                },
                e => { this.GeoFencingMap = []; this.loaderService.hide(); }
            );
        }
        else {
            this.LiveMap(this.LatLon);
        }
    }

    close(result: boolean) {
        this.done.emit(result);
    }

    LiveMap(latlon: string, Type: number = 1, data: GeoFencingMap[] = []) {
        this.MapOption = [];
        let image = this.completed;
        let ll = latlon.split(',');
        let lat: number = +ll[0];
        let lon: number = +ll[1];
        if (Type == 1) {
            this.MapOption.push({ Id: 1, Lat: lat, Lon: lon, image: image, Title: 'The attachment was made in the following coordinates Latitude & Longitude', Reason: '' });
        }
        else {
            data.forEach(e => {
                if (e.Moblat)
                    this.MapOption.push({ Id: e.StatusId, Lat: +e.Moblat, Lon: +e.MobLan, image: e.StatusId == 4 ? this.onsite : this.completed, Title: e.StatusId == 4 ? 'Onsite' : 'Completed', Reason: e.MobReason });
            });
        }

        if (this.mapId == "1")
            this.BingMap(this.MapOption);
        else if (this.mapId == "2")
            this.GoogleMap(this.MapOption);
    }

    BingMap(data: GeoFencingMapOption[]) {

        this.sharedService.getMapKey(super.globalInfo().MapKey).subscribe(res => {
            if (res.Message.Severity == Severities.success) {
                if (data.length > 0) {
                    data = data.sort((a, b) => b.Id - a.Id);
                    setTimeout(function () {
                        var map = new Microsoft.Maps.Map(
                            document.getElementById('map'),
                            {
                                credentials: res.Data,
                                center: new Microsoft.Maps.Location(data[0].Lat, data[0].Lon),
                                mapTypeId: Microsoft.Maps.MapTypeId.ROADMAP,
                                zoom: 7
                            });
        
                        data.forEach(element => {
                            let latlona = new Microsoft.Maps.Location(element.Lat, element.Lon);
                            let pushPin = new Microsoft.Maps.Pushpin(latlona, {
                                icon: element.image, width: 15, height: 15,
                                draggable: true
                            });
                            pushPin.metadata = {
                                description: ''
                            };
                            map.entities.push(pushPin);
                        });
        
                    }, 1000);
                }
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[3],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                    detail: this.translate.instant("INVALIDKEY")
                });
                return;
            }
        });
       
    }

    GoogleMap(data: GeoFencingMapOption[]) {
        if (data.length > 0) {
            data = data.sort((a, b) => a.Id - b.Id);
            setTimeout(function () {
                var map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 10,
                    center: { lat: data[0].Lat, lng: data[0].Lon }
                });

                data.forEach(element => {
                    let image = {
                        url: element.image,
                        scaledSize: new google.maps.Size(24, 24) // scaled size
                    };
                    let marker = new google.maps.Marker({
                        position: new google.maps.LatLng(element.Lat, element.Lon),
                        map: map,
                        icon: image,
                        animate: google.maps.Animation.DROP

                    });
                });

            }, 1000);
        }
    }
}